import * as React from "react";
const SvgChartBar20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "black",
        viewBox: "0 0 18 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M2 16V0H0v18h18v-2H2Zm9-15h6v13h-6V1Zm2 2v9h2V3h-2ZM4 6h6v8H4V6Zm2 2v4h2V8H6Z",
      clipRule: "evenodd"
    })
  );
export default SvgChartBar20Px;
